module.exports = __webpack_public_path__ + "static/story4-03-800x533-b66027ec8627e81e5f225fae5e8e7911.jpg";